import CompanyQuoteSecurity from './CompanyQuoteSecurity'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteSecurityContainer from './CompanyQuoteSecurityContainer'

export { CompanyQuoteSecurity }
export default CompanyQuoteSecurity
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteSecurityContainer }
// export default { CompanyQuoteSecurityContainer }
